import { IUser } from './../../models/User';

export const getCampaignDetails = async (client: { query: Function }, campaignId: string, gql: Function) => {
  return await client.query({
    query: gql`
      query fetchLandingPageData {
        getCampaign(CampaignId: ${campaignId}) {
          backgroundcolor
          BackgroundImage
          BodyTextColor
          BotId
          BrandInstagramUrl
          BlockAssociatedCampaigns
          AssociatedCampaigns
          BrandName
          BrandRetailLocationsScript
          BrandRetailLocationsUrl
          BrandUrl
          ButtonColor
          ButtonTextColor
          CampaignDescription
          CampaignHeader
          CampaignId
          ChatButtonColor
          ChatButtonTextColor
          ChatConfigId
          DMA
          DtcOnly
          DtcWithReceipt
          EmailImage
          EndDate
          EnlargeLogoImage
          FacebookPixel
          FollowupConfigUrl
          FollowupEndDate
          FollowupOffer
          FollowupOfferRedemptionUrl
          FollowupProductName
          FollowupRebateAmount
          FollowupRebateRequirement
          Geofence
          HeaderImage
          HeaderTextColor
          InStoreLocation
          InStoreLocationImage
          InitialOffer
          IsActive
          IsSweepstakes
          AllRetailers
          IsMarketplaceActive
          LegalText
          LogoImage
          LogoImageWide
          ProductName
          ProductNameDtc
          ProductUrl
          RebateAmount
          RebateRequirement
          RebateRequirementTimegate
          RedemptionCustomMessage
          RemainingInventory
          RestrictByReferrer
          Retailers {
            Id
            Name
            LogoUrl
            Url
          }
          ShopifyProductId
          ShopifyStorefrontToken
          ShopifyStorefrontUrl
          ShowBackgroundImage
          ShowDivider
          ShowStoreLocator
          StartingInventory
          StartDate
          TextColor
          TextColor
          UseAcceleratedFlow
          UseBatchMethod
          ValidReferrerString
          Fonts
          SkipLandingIntro
          Font {
            Id
            FontUrl
            FontName
            FontFamily
            CreatedBy
            CreatedAt
          }
          FieldAgents {
            Id
            InternalComment
            IsActive
            Reward
            Requirements {
              Id
              Description
              ResponseQuestion
              ResponseQuestionType
            }
         }
        }
      }
    `,
    fetchPolicy: 'network-only',
  });
};

export const getActiveCampaigns = async (client: { query: Function }, currentDate: string, gql: Function) => {
  return await client.query({
    query: gql`
      query MyQuery {
        listCampaigns(filter: { IsActive: { eq: true }, EndDate: { gt: "${currentDate}" }, IsFeatured: {eq: true} }) {
          items {
            CampaignId
            BrandName
            BrandUrl
            BrandInstagramUrl
            LogoImage
            LogoImageWide
            EndDate
            ButtonColor
            ButtonTextColor
            BackgroundImage
            ChatButtonColor
            ChatButtonTextColor
            IsActive
            CampaignDescription
            TextColor
            RemainingInventory
            StartingInventory
            ParticipatingRetailers
            DMA
            Geofence
          }
        }
      }
    `,
  });
};

export const getAllRetailers = async (client: { query: Function }, gql: Function) => {
  return await client.query({
    query: gql`
      query MyQuery {
        listRetailers {
          items {
            Id
            LogoUrl
            Name
            Url
          }
        }
      }
    `,
  });
};

export const getUserDetails = async (client: { query: Function }, EmailAddress: string, gql: Function) => {
  return await client.query({
    query: gql`
      query MyQuery {
        getUser(EmailAddress: "${EmailAddress}") {
          items {
            Email
            FirstName
            LastName
            Gender
            City
            State
            Zip
            Age
            HouseholdInfo
            PaymentServicePreference
            NewOffersNotification
          }
        }
      }
    `,
  });
};

export const getUserCompletedCampaigns = async (client: { query: Function }, UserId: string, gql: Function) => {
  return await client.query({
    query: gql`
      query MyQuery {
        getUserCompletedCampaigns(id: "${UserId}") {
          items {
            Id
            Amount
            CampaignId
            CompletedDate
            CompletedFlowNum
            CompletedFollowupNum
            CreatedDate
            CurrentStatus
            DatePaid
            DateRedeemed
            OfferExpirationDate
            OfferExpirationExtended
            UpdatedDate
            OfferExpired
            CurrentStatus
            Paid
            BrandName
          }
        }
      }
    `,
  });
};

export const hasUserCompletedAssociatedCampaigns = async (
  client: { query: Function },
  gql: Function,
  UserEmail: string,
  AssociatedCampaigns: number[]
) => {
  return await client.query({
    query: gql`
    query MyQuery { 
      isCampaignCompletedByUser(EmailAddress: "${UserEmail}", CampaignIds: [${AssociatedCampaigns}])
    }
    `,
  });
};

export const getPaymentId = async (client: { query: Function }, Id: string, gql: Function) => {
  return await client.query({
    query: gql`
      query MyQuery {
        getPaymentId(Id: "${Id}") {
            isExists
        }
      }
    `,
  });
};

export const createUser = async (client: { mutate: Function }, EmailAddress: string, gql: Function) => {
  return await client.mutate({
    mutation: gql`
    mutation MyMutation {
      addUser(EmailAddress: "${EmailAddress}") {
        FirstName
        LastName
        Gender
        City
        State
        Zip
        PaymentServicePreference
        PaymentServiceId
        Age
        Email
        HouseholdInfo
        EmailAddress
        NewOffersNotification
      }
    }
    `,
    variables: {
      EmailAddress: EmailAddress,
    },
  });
};

export const updateUser = async (client: { mutate: Function }, userDetails: IUser, gql: Function) => {
  const {
    Email,
    Age,
    City,
    FirstName,
    LastName,
    State,
    HouseholdInfo,
    Gender,
    Zip,
    PaymentServicePreference,
    PaymentServiceId,
    NewOffersNotification,
  } = userDetails;
  return await client.mutate({
    mutation: gql`
    mutation MyMutation($HouseholdInfo: [String]) {
      updateUser(Email: "${Email}", Age: "${Age}", City: "${City}", FirstName: "${FirstName}", LastName: "${LastName}", State: "${State}", HouseholdInfo: $HouseholdInfo, Gender: "${Gender}", Zip: "${Zip}", PaymentServicePreference: "${PaymentServicePreference}", PaymentServiceId: "${PaymentServiceId}", NewOffersNotification: ${NewOffersNotification} ) {
        Email
        Age
        City
        FirstName
        LastName
        State
        EmailAddress
        HouseholdInfo
        Gender
        Zip
        PaymentServicePreference
        PaymentServiceId
        NewOffersNotification
      }
    }
    `,
    variables: {
      Email: Email,
      FirstName: FirstName,
      LastName: LastName,
      Age: Age,
      Gender: Gender,
      City: City,
      State: State,
      Zip: Zip,
      HouseholdInfo: HouseholdInfo,
      PaymentServicePreference: PaymentServicePreference,
      PaymentServiceId: PaymentServiceId,
      NewOffersNotification: NewOffersNotification,
    },
  });
};

export const getCampaignQuestions = async (client: { query: Function }, campaignId: string, gql: Function) => {
  return await client.query({
    query: gql`
      query fetchCampaignQuestions {
        getCampaignQuestions(CampaignId: ${campaignId}) {
          CampaignId
          QuestionId
          Label
          MaxSelections
          MinSelections
          ResponseOptions
          Type
          IsCustom
          IsActive
        }
      }
    `,
  });
};
